import {connect} from '../../app/connect';
import {getCurrentViewType, isFiltered} from '../../app/selectors';
import ProjectListFilterPanel from './ProjectListFilterPanel';
import {setQueryParamsAction} from '../../app/actions';

const mapStateToProps = state => ({
  viewType: getCurrentViewType(state),
  isFiltered: isFiltered(state)
});

const mapDispatchToProps = {
  setQueryParamsAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectListFilterPanel);
